import { IconDefaultCard, IconMasterCardSquare, IconPayPalSquare, IconVisaSquare } from '@/assets/static/icons';

export function getCardIcon(brand?: string | null) {
  switch (brand) {
    case 'visa':
      return (
        <span className="size-10">
          <IconVisaSquare />
        </span>
      );
    case 'mastercard':
      return (
        <span className="size-10">
          <IconMasterCardSquare />
        </span>
      );
    case 'paypal':
      return <IconPayPalSquare />;
    default:
      return (
        <span className="size-10">
          <IconDefaultCard className="size-10 rounded-lg" />
        </span>
      );
  }
}
